import {Injectable, Signal} from '@angular/core';
import {httpResource} from '@angular/common/http';
import {environment} from '../../environments/environment';

export interface WishlistExists {
  exists: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class WishlistService {
  constructor() { }

  getWishlist(userId: Signal<string>, propertyId: Signal<string>) {
    return httpResource<WishlistExists>(() =>
      userId() && propertyId() ? `${environment.apiUrl}/user/${userId()}/wishlist/${propertyId()}` : undefined);
  }

}
